export default __webpack_public_path__ + "static/media/ac_mode_cool.22be7bfa.svg";